<script>
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import EmptyHeader from '@itslearning/prometheus/assets/nodes/EmptyHeader/v1/EmptyHeader.svelte';
    import LoadingSpinner from '@itslearning/prometheus/assets/nodes/LoadingSpinner/v1/LoadingSpinner.svelte'
    import PageCompleted from '../PageCompleted.svelte';
    import PageView from '../PageView.svelte';
    import PageEditQuestion from '../PageEditQuestion.svelte';
    import PagePrint from '../PagePrint.svelte';
    import PageTake from '../PageTake.svelte';
    import PageEdit from '../PageEdit.svelte';
    import PageViewAnswer from '../PageViewAnswer.svelte';
    import PageResultSummary from '../PageResultSummary/PageResultSummary.svelte';
    import { onMount } from 'svelte';
    import { survey, navigation, isInActiveForRespondents, hasDeadlinePassedForRespondents } from '../../stores.js';
    import { buildVersion, buildDate } from '../../constants.js';
    import { navigateToEditSurveyPage } from '../../navigation';
    import {IframeContentHeightReporter} from '../../IframeContentHeightReporter.js';
    import { txt } from '../../i18n/i18n';
    import { isInIframe, loadSurvey } from '../../helpers';
    
    $: hasLoadedData = false;
    $: errorFromApi = false;
    $: isNotCompleted = (isNaN(Date.parse($survey.completed)) || Date.parse($survey.completed) < 0);
    let warningText = txt('Unknown_error');

    onMount(async() => {
        console.log("Version", buildVersion, "Date", buildDate);
        errorFromApi = await loadSurvey();
        
        if(!errorFromApi){
            hasLoadedData = true;

            if (!$survey.isCreated) {
                navigateToEditSurveyPage(false);
            }
        }
        IframeContentHeightReporter.setUpIframeContentHeightReporter();
    });

    function completedOpenExternSurvey() {
        return !isInIframe() &&  $survey.respondentType === 3 && $survey.completed !== null;
    }
</script>

<!-- 
    TODO we can do this if e.g. we see that many of the pages will contain duplicate code (use a slot in a new 'base' page component)
    <Page page={$navigation.page}></Page> 
-->
{#if !isInIframe()}
    <EmptyHeader logo={'itsl'} />
{/if}
<main id="SurveyMain">
{#if !hasLoadedData && !errorFromApi}
    <div class="spinner">
        <LoadingSpinner size="large" visible={!hasLoadedData && !errorFromApi}/>
    </div>
{:else}
    {#if errorFromApi}
        <Banner type="warning" text={warningText} close={txt('Close')}  visible="{errorFromApi}" />
    {:else}
        <Banner type="info" text={$isInActiveForRespondents ? txt('Survey_inactive_message') : txt('Deadline_has_passed_message')} close={txt('Close')}  visible="{($hasDeadlinePassedForRespondents || $isInActiveForRespondents) && isNotCompleted}" />
        {#if $navigation.page === 'Take'}
            <PageTake></PageTake>
        {:else if $navigation.page === 'Print'}
            <PagePrint></PagePrint>
        {:else if $navigation.page === 'EditQuestion'}
            <PageEditQuestion></PageEditQuestion>
        {:else if $navigation.page === 'Edit'}
            <PageEdit></PageEdit>
        {:else if $navigation.page === 'ViewAnswer'}
            <PageViewAnswer></PageViewAnswer>
        {:else if $navigation.page === 'Summary'}
            <PageResultSummary></PageResultSummary>
        {:else if $navigation.page === 'Completed' || completedOpenExternSurvey()}
            <PageCompleted />
        {:else}
            <PageView></PageView>
        {/if}
    {/if}
{/if}
</main> 

